import { render, staticRenderFns } from "./ResultadoGrafico.vue?vue&type=template&id=6d280ced&scoped=true"
import script from "./ResultadoGrafico.vue?vue&type=script&lang=js"
export * from "./ResultadoGrafico.vue?vue&type=script&lang=js"
import style0 from "./ResultadoGrafico.vue?vue&type=style&index=0&id=6d280ced&prod&scoped=true&lang=css"
import style1 from "./ResultadoGrafico.vue?vue&type=style&index=1&id=6d280ced&prod&lang=scss"
import style2 from "./ResultadoGrafico.vue?vue&type=style&index=2&id=6d280ced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d280ced",
  null
  
)

export default component.exports